"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SprinklerGroup = void 0;
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const pipeNode_1 = require("../pipe/pipeNode");
class SprinklerGroup {
    constructor(points, oddLevelPoints) {
        this._riserName = "";
        this._points = points;
        this.generateRiser(oddLevelPoints);
        this._riserNode = new pipeNode_1.PipeNode(this._riserPoint, pipeNode_1.PipeNodeType.Main);
        this.link();
    }
    generateRiser(oddLevelPoints) {
        //计算应该放在哪两个点中间
        let index = Math.ceil(oddLevelPoints.length / 2) - 1;
        //为了避免立管位置和偶数层喷头位置冲突，所以放在两个点的四分之一处
        let p1 = oddLevelPoints[index];
        let p2 = oddLevelPoints[index + 1];
        this._riserPoint = new Coordinate_js_1.default(p1.x + (p2.x - p1.x) / 4, p1.y);
    }
    link() {
        let leftPoints = new Array();
        let rightPoints = new Array();
        for (let point of this._points) {
            if (point.x < this._riserPoint.x) {
                leftPoints.push(point);
            }
            else {
                rightPoints.push(point);
            }
        }
        let leftNodes = new Array();
        for (let i = leftPoints.length - 1; i >= 0; i--) {
            let node = new pipeNode_1.PipeNode(leftPoints[i], pipeNode_1.PipeNodeType.Child);
            if (i == leftPoints.length - 1) {
                this._riserNode.addChildNode(node);
            }
            else {
                leftNodes[leftNodes.length - 1].addChildNode(node);
            }
            leftNodes.push(node);
        }
        let rightNodes = new Array();
        for (let i = 0; i < rightPoints.length; i++) {
            let node = new pipeNode_1.PipeNode(rightPoints[i], pipeNode_1.PipeNodeType.Child);
            if (i == 0) {
                this._riserNode.addChildNode(node);
            }
            else {
                rightNodes[rightNodes.length - 1].addChildNode(node);
            }
            rightNodes.push(node);
        }
    }
}
exports.SprinklerGroup = SprinklerGroup;
